import React from "react";
import useDialogLauncher from "@hooks/@lore/dialogs-routable/_hooks/useDialogLauncher";
import {DialogManager} from "@/dialogs_new/DialogManager";

export default function ContactListItem({contact}) {
  const launch = useDialogLauncher();

  function onClick(e) {
    e.preventDefault();
    launch(DialogManager.UserView.Config(contact.id));
  }

  return (
    <li className="flex items-start justify-between gap-4">
      <div className="min-w-0 w-full">
        <button
          onClick={onClick}
          className="hover:underline cursor-pointer text-left w-full"
          title={contact.title}
        >
          <div className="truncate">{contact.firstName} {contact.lastName}</div>
        </button>
      </div>
    </li>
  );
}
